document.getElementById("mobile-active").addEventListener("click", function (e) {
	e.preventDefault();
	if (!this.classList.contains("active")) {
		this.classList.add("active");
		document.body.classList.add("mobile-open");
		this.nextElementSibling.classList.add("active");
	} else {
		this.classList.remove("active");
		document.body.classList.remove("mobile-open");
		this.nextElementSibling.classList.remove("active");
	}
});
document.querySelectorAll("a").forEach((element) => {
	element.addEventListener("click", function (e) {
		if (element.getAttribute("href") == "#") {
			e.preventDefault();
		}
		if (element.getAttribute("href") == "#top") {
			e.preventDefault();
			window.scrollTo(0, 0);
		}
	});
});
window.addEventListener("scroll", function () {
	let body = document.getElementsByTagName("body")[0];

	if (document.documentElement.scrollTop > 50) {
		if (!body.classList.contains("scrolled")) {
			body.classList.add("scrolled");
		}
	} else {
		if (body.classList.contains("scrolled")) {
			body.classList.remove("scrolled");
		}
	}
});

document.querySelectorAll(".main-navigation > .menu-item > .sub-menu-button").forEach((button) => {
	button.addEventListener("click", function (e) {
		e.preventDefault();
		if (this.classList.contains("active")) {
			this.classList.remove("active");
			this.nextElementSibling.classList.remove("active");
		} else {
			this.classList.add("active");
			this.nextElementSibling.classList.add("active");
		}
	});
});
